import { sidebarLink } from "../types/sidebarLink";
import { StoreModesArray } from "../types/modules/store/storeModes.type";


export const hasMode = (modeToCheck: string, modes: StoreModesArray): boolean => {
    return modes.includes(modeToCheck as any);
};


export const hasModes = (modesToCheck: string[], modes: StoreModesArray): boolean => {
    return modesToCheck.every(m => modes.includes(m as any));
};


export const getAllModes = (modes: StoreModesArray): StoreModesArray => {
    return modes;
};


export const supportsOrderFeatures = (modes: StoreModesArray): boolean => {
    return modes.includes("order");
};


export const supportsBookingFeatures = (modes: StoreModesArray): boolean => {
    return modes.includes("booking");
};


export const supportsLaundryFeatures = (modes: StoreModesArray): boolean => {
    return modes.includes("laundry");
};

export const supportsPosFeatures = (isPosEnabled?: boolean): boolean => {
    return isPosEnabled !== false;
};

export const bookingModeDisabledSidebarHrefs = new Set([
    "/store/staff",
    "/store/bookings",
    "/store/booking-services",
]);

export const bookingModeDisabledStoreDetailTabs = new Set([
    "products",
    "orders",
    "categories",
    "offers",
    "variant-categories",
    "laundry-services",
    "pos-orders",
]);

export const orderModeDisabledSidebarHrefs = new Set([
    "/store/orders",
    "/store/categories",
    "/store/variant-categories",
    "/store/products",
]);

export const laundryModeDisabledSidebarHrefs = new Set([
    "/store/laundry",
    "/store/laundry-services",
]);

export const orderModeDisabledStoreDetailTabs = new Set([
    "bookings",
    "staff",
    "booking-services",
    "laundry-services",
]);

export const laundryModeDisabledStoreDetailTabs = new Set([
    "products",
    "orders",
    "pos-orders",
    "categories",
    "variant-categories",
    "staff",
    "bookings",
    "booking-services",
]);

export const posDisabledSidebarHrefs = new Set([
    "/store/pos",
]);

export const filterLinksByStoreMode = (
    links: sidebarLink[],
    modes: StoreModesArray,
    isPosEnabled?: boolean
) => {
    const hasOrder = modes.includes("order");
    const hasBooking = modes.includes("booking");
    const hasLaundry = modes.includes("laundry");

    const disabledHrefs = new Set<string>();

    if (!hasBooking) {
        bookingModeDisabledSidebarHrefs.forEach(href => disabledHrefs.add(href));
    }

    if (!hasOrder) {
        orderModeDisabledSidebarHrefs.forEach(href => disabledHrefs.add(href));
    }

    if (!hasLaundry) {
        laundryModeDisabledSidebarHrefs.forEach(href => disabledHrefs.add(href));
    }

    if (!supportsPosFeatures(isPosEnabled)) {
        posDisabledSidebarHrefs.forEach(href => disabledHrefs.add(href));
    }

    return links.filter((link) => !link.href || !disabledHrefs.has(link.href));
};